/**
 * Crisp客服系统配置文件
 */

export const CRISP_CONFIG = {
  // Crisp网站ID - 使用官方文档示例ID
  websiteId: "328dd283-6ebf-4f40-bcea-39ec8fda91a4",

  // 是否启用客服系统
  enabled: true,

  // 是否自动加载
  autoLoad: true,
  
  // 默认设置
  defaultSettings: {
    // 默认语言
    language: 'zh',
    
    // 是否启用声音通知
    soundEnabled: true,
    
    // 是否启用桌面通知
    desktopNotifications: true,
    
    // 聊天窗口主题色
    theme: {
      primary: '#0066FF',
      secondary: '#F0F0F0'
    }
  },
  
  // 自动消息配置
  autoMessages: {
    // 欢迎消息
    welcome: {
      enabled: true,
      delay: 3000, // 3秒后显示
      message: "👋 您好！有什么可以帮助您的吗？"
    },
    
    // 离开页面提醒
    beforeUnload: {
      enabled: false,
      message: "确定要离开吗？我们的客服随时为您服务！"
    }
  },
  
  // 用户信息映射
  userMapping: {
    // 是否自动设置用户信息
    autoSetUser: true,
    
    // 用户信息字段映射
    fields: {
      email: 'email',
      nickname: 'name',
      phone: 'phone',
      avatar: 'avatar'
    }
  },
  
  // 页面特定配置
  pageSettings: {
    // 登录页面
    '/login': {
      enabled: false, // 登录页面不显示客服
    },
    
    // 注册页面
    '/register': {
      enabled: false, // 注册页面不显示客服
    },
    
    // 忘记密码页面
    '/forgot-password': {
      enabled: false,
    },
    
    // 仪表板页面
    '/dashboard': {
      enabled: true,
      autoMessage: "欢迎使用我们的服务！如有任何问题，请随时联系我们。"
    },
    
    // 服务器列表页面
    '/servers': {
      enabled: true,
      autoMessage: "需要帮助选择合适的服务器吗？"
    },
    
    // 套餐页面
    '/plans': {
      enabled: true,
      autoMessage: "对我们的套餐有疑问吗？我来为您详细介绍！"
    },
    
    // 订单页面
    '/orders': {
      enabled: true,
      autoMessage: "订单有问题？我来帮您查看！"
    }
  }
}

/**
 * 获取当前页面的Crisp配置
 * @param {string} pathname - 当前页面路径
 * @returns {Object} 页面配置
 */
export function getPageCrispConfig(pathname) {
  const pageConfig = CRISP_CONFIG.pageSettings[pathname] || {}
  
  return {
    ...CRISP_CONFIG,
    ...pageConfig,
    enabled: CRISP_CONFIG.enabled && (pageConfig.enabled !== false)
  }
}

/**
 * 检查当前页面是否应该显示客服
 * @param {string} pathname - 当前页面路径
 * @returns {boolean}
 */
export function shouldShowCrisp(pathname) {
  const config = getPageCrispConfig(pathname)
  return config.enabled
}

/**
 * 获取页面特定的自动消息
 * @param {string} pathname - 当前页面路径
 * @returns {string|null}
 */
export function getPageAutoMessage(pathname) {
  const pageConfig = CRISP_CONFIG.pageSettings[pathname]
  return pageConfig?.autoMessage || null
}

export default CRISP_CONFIG
